import Result from "@/core/common/Result";

export interface IIniciarVoucherUseCase {
  sendDataVisualizacao(id: string, date: string): Promise<Result<void>>;
}

export const iniciarVoucherUseCaseDI = "iniciarVoucherUseCaseDI";
